var _style, _path, _g, _circle, _path2, _rect, _rect2, _path3, _path4, _text, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetiraconpagomovil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 233.2",
    style: {
      enableBackground: "new 0 0 1500 233.2"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#05D5D2;}\r\n\t.st1{fill:#006FB9;}\r\n\t.st2{fill:#FBFFFE;}\r\n\t.st3{fill:#0071B7;}\r\n\t.st4{fill:#046FB8;}\r\n\t.st5{fill:none;stroke:#E8FFFF;stroke-width:5.1232;stroke-miterlimit:10;}\r\n\t.st6{font-family:'Gotham-Black';}\r\n\t.st7{font-size:88.2653px;}\r\n\t.st8{fill:#FAFCFB;stroke:#016EC1;stroke-width:3;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.3,167c-0.4,0.3-0.7,0.5-1.1,0.7C297.6,167.5,298,167.3,298.3,167z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,80.3h35.6c11.5,0,19.5,3,24.6,8.2c4.4,4.3,6.6,10.2,6.6,17.5v0.2c0,11.5-6.2,19.2-15.5,23.2l18,26.3H62.7L47.5,133 h-0.2h-9v22.8H17.4V80.3z M52.2,116.5c7.1,0,11.2-3.4,11.2-9v-0.2c0-5.9-4.3-9-11.4-9H38.3v18.1H52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,80.3h60.7v17.7h-40v11.4h36.2v16.5h-36.2v12h40.5v17.8H94.9V80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,98.6h-22.6V80.3h66.2v18.3h-22.6v57.2h-20.9L185.2,98.6L185.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,80.3h21.1v75.4h-21.1V80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1,80.3h35.6c11.5,0,19.5,3,24.6,8.2c4.4,4.3,6.6,10.2,6.6,17.5v0.2c0,11.5-6.2,19.2-15.5,23.2l18,26.3h-24.1 L303.1,133h-0.2h-9v22.8h-20.9V80.3z M307.8,116.5c7.1,0,11.2-3.4,11.2-9v-0.2c0-5.9-4.3-9-11.4-9H294v18.1H307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.4,79.8h20.1l32.1,76h-22.4l-5.5-13.5h-29.1l-5.4,13.5h-22L375.4,79.8z M393.7,126.1l-8.4-21.4l-8.5,21.4H393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.3,118.3v-0.2c0-22,16.9-39.2,39.8-39.2c15.4,0,25.3,6.5,32,15.7l-15.7,12.2c-4.3-5.4-9.2-8.9-16.5-8.9 c-10.5,0-18,9-18,19.9v0.2c0,11.4,7.5,20.1,18,20.1c7.8,0,12.5-3.7,17-9.1l15.7,11.2c-7.1,9.8-16.7,17-33.4,17 C479.7,157.3,462.3,140.8,462.3,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.8,118.3v-0.2c0-21.7,17.5-39.2,40.7-39.2c23.3,0,40.5,17.4,40.5,39.1v0.2c0,21.7-17.5,39.2-40.7,39.2 C556,157.3,538.8,139.9,538.8,118.3z M598.7,118.3v-0.2c0-10.9-7.8-20.4-19.4-20.4c-11.4,0-19.1,9.2-19.1,20.1v0.2 c0,10.9,7.8,20.4,19.3,20.4C591.1,138.4,598.7,129.2,598.7,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.9,80.3h19.5l31,39.9V80.3h20.7v75.4h-18.3l-32.1-41.4v41.4H631L630.9,80.3L630.9,80.3z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 797.2,
    cy: 117.2,
    r: 77.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M821,176.5h-47.7c-5.8,0-10.5-4.7-10.5-10.5V68.4c0-5.8,4.7-10.5,10.5-10.5H821c5.8,0,10.5,4.7,10.5,10.5v97.7 C831.5,171.8,826.8,176.5,821,176.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 768.8,
    y: 69.7,
    className: "st3",
    width: 56.8,
    height: 79.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 787.9,
    y: 61.1,
    className: "st4",
    width: 18.5,
    height: 4.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M777,112.5c0,0,18-20.4,36,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M782.8,118.9c0,0,12.2-15.4,24.4,0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 895.8356 148.7937)",
    className: "st1 st6 st7"
  }, "PAGO M\xD3VIL")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M789.6,148.3v-29.7c0-2.6,1.4-5,3.7-6.1c1.5-0.7,3.3-0.9,5.2,0.2c1.9,1.1,2.9,3.3,2.9,5.5v15 c0,0,10.8-0.5,19.3,3.8c3,1.5,4.9,4.6,4.9,8l0,15.7c0,1.1-0.2,2.2-0.7,3.2l-2.4,5.4l0.5,14.2h-36.5c0,0,0-14.6,0-14.6 c0-1.9-4.6-6.5-5.8-8.2c-2.5-3.6-8.8-12-5.2-16.5c2-2.5,6.3-2.6,8.9-1.1C785.6,143.8,789.6,146.7,789.6,148.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetiraconpagomovil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RETIRACONPAGOMOVIL.d1462762419a2d0ffe2bd4d642dd20cc.svg";